import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.5.1_@types+node@24.2.0_db0@0.3.2_encoding@0.1.13_eslint@9_efe516b856ef27ee3dd6749ee5c70e29/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/app/platform/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}